export default __webpack_public_path__ + "static/media/comic19_2.0daeb94a.png";